export const viewTitle = "Служебные справочники";
export const viewUniqKey = "serviceDirectories";
